import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { useForm, Controller } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { Editor } from "components/shared/Editor";
import { editService, getService } from "store/actions";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "components/shared/Loader";
import ImageUploadEn from "./ImageUploadEn";
import SaveChangesButton from "components/shared/SaveChangesButton";
import { toast } from "react-toastify";

const EdirService = () => {
  const { locale } = useIntl();
  const dir = locale === "ar" ? "rtl" : "ltr";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { slug } = useParams();
  const [selectedMainImage, setSelectedMainImage] = useState({
    preview: null,
    path: null,
  });
  const [selectedIcon, setSelectedIcon] = useState({
    preview: null,
    path: null,
  })


  const [description, setDescription] = useState({ ar: "", en: "" });


  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm();




  // const { languages } = useSelector((state) => state.languages);
  const { service, loading } = useSelector((state) => state.services) || {};

  useEffect(() => {

    dispatch(getService({ page: "ourServices", slug: slug }));
  }, [dispatch, slug]);

  useEffect(() => {

    reset({

      heading: {
        ar: service?.data?.heading?.ar,
        en: service?.data?.heading?.en
      },
      subHeading: {
        ar: service?.data?.subHeading?.ar,
        en: service?.data?.subHeading?.en
      },


    });
    if (service?.data?.icon) {
      setSelectedIcon({ preview: null, path: service?.data?.icon });
    }

    if (service?.data?.image) {
      setSelectedMainImage({ preview: null, path: service?.data?.image });
    }

    return () => reset({});
  }, [reset, service]);





  useEffect(() => {
    setDescription(service?.data?.description);
  }, [service]);


  const onSubmit = (data) => {
    if (selectedMainImage?.path)
      data.image = selectedMainImage.path;
    if (selectedIcon?.path)
      data.icon = selectedIcon.path;
    data.description = description;

    const sectionData = {
      section: {
        title: slug,
        data: data,
      },
    };
    dispatch(editService({ page: "ourServices", slug, data: sectionData, navigate, toast }));

  };


  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id="editServices" />
            </h4>
          </div>
          <div className="card-body form-group settings-tabs">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={10} md={12}>
                <Row>
                  {/* Main Image Upload */}
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5><FormattedMessage id="image" /></h5>
                      <ImageUploadEn
                        selectedImageEn={selectedMainImage}
                        setSelectedImageEn={setSelectedMainImage}
                        accept="image/*"
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5><FormattedMessage id="icon" /></h5>
                      <ImageUploadEn
                        selectedImageEn={selectedIcon}
                        setSelectedImageEn={setSelectedIcon}
                        accept="image/svg+xml, image/jpeg, image/png"
                      />
                    </div>
                  </Col>



                  {/* Title Inputs */}
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5> <FormattedMessage id="title" />  (<FormattedMessage id="arabic-language" />) </h5>
                      <input
                        type="text"
                        className="form-control"
                        {...register("heading.ar", { required: true })}
                      />
                      <p className="error-hint">
                        {errors.heading?.ar?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5> <FormattedMessage id="title" />  (<FormattedMessage id="english-language" />) </h5>

                      <input
                        type="text"
                        className="form-control"
                        {...register("heading.en", { required: true })}
                      />
                      <p className="error-hint">
                        {errors.heading?.en?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>

                  {/* Title Inputs */}
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5> <FormattedMessage id="subTitle" />  (<FormattedMessage id="arabic-language" />) </h5>
                      <input
                        type="text"
                        className="form-control"
                        {...register("subHeading.ar", { required: true })}
                      />
                      <p className="error-hint">
                        {errors.subHeading?.ar?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5> <FormattedMessage id="subTitle" />  (<FormattedMessage id="english-language" />) </h5>
                      <input
                        type="text"
                        className="form-control"
                        {...register("subHeading.en", { required: true })}
                      />
                      <p className="error-hint">
                        {errors.subHeading?.en?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>



                  {/* Description Editors */}
                  <Col lg={12}>
                    <div className="form-group required">
                      <h5> <FormattedMessage id="description" /> (<FormattedMessage id="arabic-language" />) </h5>
                      <Controller
                        control={control}
                        name="description.ar"
                        render={() => (
                          <Editor
                            initialValue={description?.ar}
                            onChange={(e, editor) => {
                              const data = editor.getContent();
                              setDescription((prev) => ({
                                ...prev,
                                ar: data,
                              }));
                            }}
                          />
                        )}
                      />
                      <p className="error-hint">
                        {errors.description?.ar?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="form-group required">
                      <h5> <FormattedMessage id="description" /> (<FormattedMessage id="english-language" />) </h5>
                      <Controller
                        control={control}
                        name="description.en"
                        render={() => (
                          <Editor
                            initialValue={description?.en}
                            onChange={(e, editor) => {
                              const data = editor.getContent();
                              setDescription((prev) => ({
                                ...prev,
                                en: data,
                              }));
                            }}
                          />
                        )}
                      />
                      <p className="error-hint">
                        {errors.description?.en?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>



                </Row>
              </Col>




              <SaveChangesButton />

            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EdirService;
